/**
 * Global toast (handoff §5.6). Renders a pill at bottom-center when `message` is non-empty
 * and auto-clears after ~2.8s. Used for: download started, "Adversarial review passed".
 * Copy uses a button-label swap instead (§5.2), not this.
 */

import { useEffect } from 'react';
import { color, font } from '../tokens';

const AUTO_CLEAR_MS = 2800;   // §5.6: "Auto-clears 2.4–3.2s later."

export default function Toast({ message, onClear }: { message: string; onClear: () => void }) {
  useEffect(() => {
    if (!message) return;
    const t = setTimeout(onClear, AUTO_CLEAR_MS);
    return () => clearTimeout(t);
  }, [message, onClear]);

  if (!message) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      style={{
        position: 'fixed', bottom: 28, left: '50%', transform: 'translateX(-50%)',
        background: color.ink, color: '#fff', padding: '11px 20px', borderRadius: 999,
        fontFamily: font.ui, fontSize: 13.5, fontWeight: 600,
        boxShadow: '0 8px 24px #0d0b2b40', zIndex: 60, pointerEvents: 'none',
      }}
    >
      {message}
    </div>
  );
}
